import { render, staticRenderFns } from "./ScoreLockExaminationRoom.vue?vue&type=template&id=2b8e0f66&"
import script from "./ScoreLockExaminationRoom.vue?vue&type=script&lang=js&"
export * from "./ScoreLockExaminationRoom.vue?vue&type=script&lang=js&"
import style0 from "./ScoreLockExaminationRoom.vue?vue&type=style&index=0&id=2b8e0f66&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports